const THAI = /[\u0E00-\u0E7F]/;
const ENG_LETTER = /[A-Za-z]/;

export function hasThai(value) {
  return THAI.test(value || "");
}

export function isThaiName(value) {
  const v = (value || "").trim();
  if (!v) return false;
  if (ENG_LETTER.test(v) || /[0-9]/.test(v)) return false;
  return /^[\u0E00-\u0E7F\s.\-]+$/.test(v);
}

export function isEnglishName(value) {
  const v = (value || "").trim();
  if (!v) return false;
  if (THAI.test(v)) return false;
  return /^[A-Za-z\s.\-']+$/.test(v);
}

export function isEmailFormat(value) {
  const v = (value || "").trim();
  if (!v) return false;
  if (THAI.test(v)) return false;
  if (/\s/.test(v)) return false;
  return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v);
}

export function isThaiPhone(value) {
  const v = (value || "").replace(/[-\s]/g, "");
  return /^0[0-9]{8,9}$/.test(v);
}

export function isZipcode(value) {
  return /^[0-9]{5}$/.test((value || "").trim());
}

export function isCitizenId(value) {
  return /^[0-9]{13}$/.test((value || "").trim());
}

export const rulesThaiName = (label) => ({
  required: `กรุณากรอก${label}`,
  validate: {
    thai: (v) =>
      isThaiName(v) || `${label}ต้องเป็นภาษาไทยเท่านั้น ห้ามภาษาอังกฤษหรือตัวเลข`,
  },
});

export const rulesEnglishName = (label) => ({
  required: `กรุณากรอก${label}`,
  validate: {
    english: (v) =>
      isEnglishName(v) || `${label}ต้องเป็นภาษาอังกฤษเท่านั้น ห้ามมีภาษาไทย`,
  },
});

export const rulesEmail = {
  required: "กรุณากรอกอีเมล",
  validate: {
    noThai: (v) => !hasThai(v) || "อีเมลห้ามมีภาษาไทย",
    format: (v) => isEmailFormat(v) || "รูปแบบอีเมลไม่ถูกต้อง เช่น name@example.com",
  },
};

export const rulesEmailOrDash = {
  required: "กรุณากรอกอีเมล หรือใส่ - หากไม่มี",
  validate: {
    noThai: (v) => !hasThai(v) || "อีเมลห้ามมีภาษาไทย",
    format: (v) => {
      const t = (v || "").trim();
      if (t === "-") return true;
      return isEmailFormat(t) || "รูปแบบอีเมลไม่ถูกต้อง หรือใส่ - หากไม่มี";
    },
  },
};

export const rulesPhone = {
  required: "กรุณากรอกเบอร์โทรศัพท์",
  validate: {
    phone: (v) => isThaiPhone(v) || "เบอร์โทรต้องเป็นตัวเลข 9–10 หลัก ขึ้นต้นด้วย 0 เช่น 0812345678",
  },
};

export const rulesZipcode = {
  required: "กรุณากรอกรหัสไปรษณีย์",
  validate: {
    zip: (v) => isZipcode(v) || "รหัสไปรษณีย์ต้องเป็นตัวเลข 5 หลัก",
  },
};

export const FIELD_LABELS = {
  citizent: "เลขบัตรประชาชน",
  pname: "คำนำหน้า",
  name: "ชื่อภาษาไทย",
  lname: "นามสกุลภาษาไทย",
  name_eng: "ชื่อภาษาอังกฤษ",
  lname_eng: "นามสกุลภาษาอังกฤษ",
  telephone: "เบอร์โทรศัพท์มือถือ",
  mobile_pre: "เบอร์โทรศัพท์ผู้ปกครอง",
  ddate: "วันเกิด",
  mdate: "เดือนเกิด",
  ydate: "ปีเกิด",
  email: "อีเมล",
  facebookid: "ชื่อ Facebook",
  line_id: "Line ID",
  nation_study: "สัญชาติ",
  believe_study: "เชื้อชาติ",
  religion_study: "ศาสนา",
  weight_study: "น้ำหนัก",
  height_study: "ส่วนสูง",
  waistline_study: "รอบเอว",
  talent_study: "ความสามารถพิเศษ",
  number_study: "บ้านเลขที่",
  moo_study: "หมู่ที่",
  soi_study: "ซอย",
  street_study: "ถนน",
  provincy_study: "จังหวัด (ที่อยู่)",
  district_study: "อำเภอ (ที่อยู่)",
  subdistrict_study: "ตำบล (ที่อยู่)",
  zipcode_study: "รหัสไปรษณีย์",
  type_pre: "ประเภทผู้ปกครอง",
  citizent_pre: "เลขบัตรประชาชนผู้ปกครอง",
  name_pre: "ชื่อผู้ปกครอง",
  lname_pre: "นามสกุลผู้ปกครอง",
  email_pre: "อีเมลผู้ปกครอง",
  number_pre: "บ้านเลขที่ผู้ปกครอง",
  moo_pre: "หมู่ที่ผู้ปกครอง",
  soi_pre: "ซอยผู้ปกครอง",
  street_pre: "ถนนผู้ปกครอง",
  provincy_pre: "จังหวัดผู้ปกครอง",
  district_pre: "อำเภอผู้ปกครอง",
  subdistrict_pre: "ตำบลผู้ปกครอง",
  zipcode_pre: "รหัสไปรษณีย์ผู้ปกครอง",
  provincework: "จังหวัดสถานที่ปฏิบัติการสอน",
  districtwork: "อำเภอสถานที่ปฏิบัติการสอน",
  schoolnamework: "สถานศึกษาที่ปฏิบัติการสอน",
  province: "จังหวัดสถานศึกษา",
  district: "อำเภอสถานศึกษา",
  schoolname: "สถานศึกษาที่สำเร็จการศึกษา",
  level: "วุฒิการศึกษา",
  plan: "แผนการเรียน",
  vga: "ผลการเรียนเฉลี่ย",
  province2: "จังหวัดสถานศึกษาระดับปริญญาโท",
  district2: "อำเภอสถานศึกษาระดับปริญญาโท",
  schoolname2: "สถานศึกษาระดับปริญญาโท",
  fileData_1: "ไฟล์หนังสืออนุญาตประกอบวิชาชีพ",
  filelevel: "ไฟล์สำเนาใบรายงานผลการเรียน",
  fileData_3: "ไฟล์สำเนาบัตรประชาชน",
  firstgen: "การศึกษาบิดาหรือมารดา",
  checkconfirm: "ยอมรับรับรองข้อมูล",
};

export function listFieldErrors(formErrors) {
  if (!formErrors || typeof formErrors !== "object") return [];
  return Object.entries(formErrors)
    .filter(([, err]) => err && (err.message || err.type))
    .map(([key, err]) => ({
      key,
      label: FIELD_LABELS[key] || key,
      message: err.message || "กรอกไม่ถูกต้อง",
    }));
}

export const rulesCitizenId = {
  required: "กรุณากรอกเลขบัตรประชาชน 13 หลัก",
  validate: {
    id: (v) => isCitizenId(v) || "เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก",
  },
};
